import React, {useState, useContext, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { UserContext } from "../context/userContext";
import Input from "../props/inputProp";
import { postData } from "../fetchRoutes/postData";
import { emailValidation, nameValidation, passwordValidation } from "../utility/validation";



export default function RegisterForm() {

    const navigate = useNavigate();

    const postUrl = process.env.REACT_APP_RESGISTER_USER;

    const {setUserDetails, setIsLoggedIn} = useContext(UserContext);
    const [selectedRole, setSelectedRole] = useState("");

    const [user, setUser] = useState({
        name: '',
        email: '',
        confirmEmail: '',
        password: '',
        confirmPassword: '',
        role: ''
        
    });


    const [isValid, setIsValid] = useState({
        email: true,
        name: true
    });
    

    const [errorMessage, setMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setConfirmPassword] = useState(false);


    const [disable, setDisable] = useState(false);
    const [emailDiasable, setEmailDisable] = useState(false);
    const [nameDiasable, setNameDisable] = useState(false);
    const [emailMatchValid, setEmailMatchValid] = useState(true);
    const [samePassword, setSamePassword] = useState(true);
    const [loading, setLoading] = useState(false);



    // Handle input change
    const handleChange = (event) => {
        const {name, value} = event.target;
        setUser({...user, [name]: value});
    }

    // Handle role change for CSS manipulation
    const handleRoleChange = (e) => {
        setSelectedRole(e.target.value);
        setUser({...user, role: e.target.value});
    };


    // Handle login button click
    const handleLogIn = () => {
        navigate("/account/login");
    }



    // Password validation checks
    useEffect(() => {
        const { password, confirmPassword } = user;

    
        if (!password.length || !confirmPassword.length) {
            setSamePassword(true);
            setDisable(true);
        } else if (!passwordValidation(password)) {
            setMessage('Password requires symbols, numbers, and uppercase');
            setSamePassword(false);
            setDisable(true);
        }else if(password !== confirmPassword) {
            setMessage('Passwords does not match!');
            setSamePassword(false);
            setDisable(true);

        }else {
            setMessage('');
            setSamePassword(true);
            setDisable(false);
        }
    }, [user, user.password, user.confirmPassword, samePassword, disable]);
    

    // Email and Name validation
    useEffect(() => {

        let emailMatch;
        const emailValid = user.email.length > 0 ? emailValidation(user.email) : true;

        if(user.confirmEmail.length>0){

            emailMatch = user.email === user.confirmEmail;
            setEmailMatchValid(emailMatch); 

        }

        // Name validation
        const nameValid = user.name.length > 0 ? nameValidation(user.name) : true;
    
        setIsValid({ email: emailValid, name: nameValid });
        setEmailDisable(user.email.length > 0 && (!emailValid || !emailMatch));
        setNameDisable(user.name.length > 0 && !nameValid);
    
        
    }, [user.email, user.confirmEmail, user.name]);
    


    // Handle post request to register user
    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);

        try{

            const response = await postData(postUrl, user);

            if(response.status === 'success'){
                navigate('/');
                setUserDetails({
                    name: user.name,
                    email: user.email,
                    role: user.role,
                    _id: response.data.user.id,
                    image: response.data.user.image,
                    notification: response.data.user.notification,
                    username: response.data.user.username
                });
                setIsLoggedIn(true);
            }

        }catch(err){

            setMessage('Something went wrong. Please try again');
            
        }finally{
            setLoading(false);
            setMessage('');
        }
    
    }


    return(

         <main className="home loginPage registerPage">
            {loading && (
                <div className="loaderContainer">
                    <div className="loader"></div>
                    <p className="loadingText">Registering you ...</p>
                </div>
            )}
        
            <div className="loginContainer registerContainer">
                {/* Company Logo  */}
                <div className="loginLogoContainer">
                    {/* Form Title */}
                    <div className="formTitle signUpFormTitle"> 
                        <p className="logInTitle">Buy. Sell. Thrive.</p>
                    </div>
                </div>

                {/* Login form container */}
                <div className="loginFormContainer registerFormContainer">
                    {/* Login form */}
                    <form className="loginForm registerForm" onSubmit={handleSubmit}>
                        {/* User Name Input */}
                        <div className="inputs">
                            <label className="label">Full Name<span className="asterisk"> *</span></label>
                            <Input
                                className={isValid.name ? "fullName":"fullName error"}
                                type='text'
                                name='name'
                                placeholder='John Smith'
                                autoCapitalize="off"
                                autoCorrect="off"
                                required
                                minLength="2"
                                value = {user.name}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Combined emails */}
                        <div className="combinedInputs">
                            {/* Email Input */}
                            <div className="inputs">
                                <label className="label">Email<span className="asterisk"> *</span></label>
                                <Input
                                    className= {isValid.email ?"email":" email error"}
                                    type='email'
                                    name='email'
                                    placeholder='this@example.com'
                                    autoCapitalize="off"
                                    autoCorrect="off"
                                    required
                                    minLength="2"
                                    value = {user.email}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Confirm Email Input */}
                            <div className="inputs">
                                <label className="label">Confirm Email<span className="asterisk"> *</span></label>
                                <Input
                                    className={`email confirmEmail ${emailMatchValid ? "" : "error"}`}
                                    type='email'
                                    name='confirmEmail'
                                    placeholder='this@example.com'
                                    autoCapitalize="off"
                                    autoCorrect="off"
                                    required
                                    minLength="2"
                                    value = {user.confirmEmail}
                                    onChange={handleChange}
                                />
                            </div>

                        </div>
                        
                        {/* Combined passwords */}
                        <div className="combinedInputs">
                            {/* Password Input */}
                            <div className="inputs">
                                <label className="label passwordInputs">
                                    <div className="passwordLabelDetail">
                                        Password<span className="asterisk"> *</span>
                                    </div>
                                    <div className="eyeContainer">
                                        <span 
                                            className="showHideIcon" 
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                        </span>
                                    </div>
                                
                                </label>
                                <Input
                                    className={samePassword ? "password" : "password error"}
                                    type={showPassword ? "text" : "password"}
                                    name='password'
                                    placeholder='........'
                                    autoCapitalize="off"
                                    autoCorrect="off"
                                    required
                                    minLength="8"
                                    value = {user.password}
                                    onChange={handleChange}
                                />
                            </div>

                            {/* Confirm Password */}
                            <div className="inputs">
                                <label className="label passwordInputs">
                                    <div className="passwordLabelDetail">
                                        Confirm Password<span className="asterisk"> *</span>
                                    </div>
                                    <div className="eyeContainer">
                                        <span 
                                            className="showHideIcon" 
                                            onClick={() => setConfirmPassword(!showConfirmPassword)}
                                        >
                                            {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                        </span>
                                    </div>
                                
                                </label>
                                <Input
                                    className={samePassword ? "password confirmPassword" : "password  confirmPassword error"}
                                    type={showConfirmPassword ? "text" : "password"}
                                    name='confirmPassword'
                                    placeholder='........'
                                    autoCapitalize="off"
                                    autoCorrect="off"
                                    required
                                    minLength="8"
                                    value = {user.confirmPassword}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                     

                        {/* Seller/Buyer Choice*/}
                        <div className="inputs">
                            <div className="radioGroup">
                                <label className={`default ${selectedRole === "buyer" ? "selected" : ""}`}>
                                    <Input
                                        className="choice"
                                        type="radio"
                                        name="role"
                                        value="buyer"
                                        required
                                        onChange={handleRoleChange}
                                    />
                                    I want to buy properties!<span className="asterisk">*</span>
                                </label>
                                <label className={`default ${selectedRole === "seller" ? "selected" : ""}`}>
                                    <Input
                                        className="choice"
                                        type="radio"
                                        name="role"
                                        value="seller"
                                        required
                                        onChange={handleRoleChange}
                                    />
                                    I want to sell properties!<span className="asterisk">*</span>
                                </label>
                            </div>
                        </div>


                        {/* Error Message */}
                        <div className="errorMessage">
                            <span className="errorMessage">{errorMessage}</span>
                        </div>
                        
                        {/* Login Button */}
                        <div className="lButton" >
                            <button className="loginButton regButton" type="submit" disabled={disable || emailDiasable || nameDiasable}> 
                                Register
                            </button> 
                        </div> 
                    </form>

                    {/* Register container */}
                    <div className="register">
                        <span className="registerNow">Already have an account?</span>
                        <button className="signUp" onClick={handleLogIn}>
                            Log In!
                        </button>
                    </div>

                    {/* Cookie Message */}
                    <div className="cookieMessage">
                        <span className="cookie">By registering, you agree to our use of cookies to keep you signed in and enhance your experience.</span>
                    </div>

                </div>

            </div>
        </main>
    )
}


